module.exports = __webpack_public_path__ + "static/assets/6181551244a4d5e367602a61b8ad81bc.svg";